import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ValidationItem {
    message: string;
    passed: boolean;
}

@Component({
    selector: 'app-submit-validation-dialog',
    standalone: false,
    templateUrl: './submit-validation-dialog.component.html'
})
export class SubmitValidationDialogComponent {
    title: string = 'Submit Inspection';
    actionText: string = 'Submit';

    constructor(
        public dialogRef: MatDialogRef<SubmitValidationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { items: ValidationItem[]; allPassed: boolean; title?: string; action?: string }
    ) {
        this.data.items = [...this.data.items].sort((a, b) => (b.passed ? 1 : 0) - (a.passed ? 1 : 0));
        if (this.data.title) {
            this.title = this.data.title;
        }
        if (this.data.action) {
            this.actionText = this.data.action;
        }
    }
}
